module.exports = __webpack_public_path__ + "img/ico_comment--white.5e82d074.svg";